import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RatersService {
  raters: any = {
    "1": {
        "name": "litmus",
        "min_score": -5,
        "max_score": 5,
        "distributions": [{
            "value": 2,
            "label": "Positives",
            "color": "#0b7139",
            "field_id": "positives"
        }, {
            "value": 1,
            "label": "Negatives",
            "color": "#ed2424",
            "field_id": "negatives"
        }],
        "prop": {
            "1": {
                "value": 1,
                "label": "#1",
                "active_color": "#f5ea14"
            },
            "2": {
                "value": 2,
                "label": "#2",
                "active_color": "#bbd531"
            },
            "3": {
                "value": 3,
                "label": "#3",
                "active_color": "#66b846"
            },
            "4": {
                "value": 4,
                "label": "#4",
                "active_color": "#0b7139"
            },
            "5": {
                "value": 5,
                "label": "#5",
                "active_color": "#06521f"
            },
            "-5": {
                "value": -5,
                "label": "#-5",
                "active_color": "#c42031"
            },
            "-4": {
                "value": -4,
                "label": "#-4",
                "active_color": "#ed2424"
            },
            "-3": {
                "value": -3,
                "label": "#-3",
                "active_color": "#f05f22"
            },
            "-2": {
                "value": -2,
                "label": "#-2",
                "active_color": "#f48020"
            },
            "-1": {
                "value": -1,
                "label": "#-1",
                "active_color": "#fab416"
            }
        },
        "average_rating_range": [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5],
        "average_rating_labels": [-5, -3, -1, 1, 3, 5],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
    },
    "2": {
        "name": "others",
        "min_score": 0,
        "max_score": 0,
        "distributions": [],
        "prop": {},
        "average_rating_range": [],
        "average_rating_labels": [],
        "percentage_labels": [],
        "number_of_ticks": 0
    },
    "3": {
        "name": "nps",
        "min_score": -100,
        "max_score": 100,
        "distributions": [{
            "value": 3,
            "label": "Promoters",
            "color": "#008000",
            "field_id": "promoters"
        }, {
            "value": 2,
            "label": "Passives",
            "color": "#ffa500",
            "field_id": "passives"
        }, {
            "value": 1,
            "label": "Detractors",
            "color": "#ff0000",
            "field_id": "detractors"
        }],
        "prop": {
            "0": {
                "value": 0,
                "label": "#0",
                "active_color": "#ed2424"
            },
            "1": {
                "value": 1,
                "label": "#1",
                "active_color": "#ed2424"
            },
            "2": {
                "value": 2,
                "label": "#2",
                "active_color": "#ed2424"
            },
            "3": {
                "value": 3,
                "label": "#3",
                "active_color": "#ed2424"
            },
            "4": {
                "value": 4,
                "label": "#4",
                "active_color": "#ed2424"
            },
            "5": {
                "value": 5,
                "label": "#5",
                "active_color": "#ed2424"
            },
            "6": {
                "value": 6,
                "label": "#6",
                "active_color": "#ed2424"
            },
            "7": {
                "value": 7,
                "label": "#7",
                "active_color": "#fab416"
            },
            "8": {
                "value": 8,
                "label": "#8",
                "active_color": "#fab416"
            },
            "9": {
                "value": 9,
                "label": "#9",
                "active_color": "#0b7139"
            },
            "10": {
                "value": 10,
                "label": "#10",
                "active_color": "#0b7139"
            }
        },
        "average_rating_range": [-100, -80, -60, -40, -20, 0, 20, 40, 60, 80, 100],
        "average_rating_labels": [-100, -60, -20, 20, 60, 100],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
    },
    "4": {
        "name": "1to5",
        "min_score": 0,
        "max_score": 5,
        "distributions": [{
            "value": 3,
            "label": "T2B",
            "color": "#10a754",
            "field_id": "top"
        }, {
            "value": 2,
            "label": "MB",
            "color": "#fab416",
            "field_id": "mid"
        }, {
            "value": 1,
            "label": "B2B",
            "color": "#ed2424",
            "field_id": "bottom"
        }],
        "prop": {
            "1": {
                "value": 1,
                "label": "#1",
                "active_color": "#c62828"
            },
            "2": {
                "value": 2,
                "label": "#2",
                "active_color": "#e53935"
            },
            "3": {
                "value": 3,
                "label": "#3",
                "active_color": "#f5ea14"
            },
            "4": {
                "value": 4,
                "label": "#4",
                "active_color": "#66b846"
            },
            "5": {
                "value": 5,
                "label": "#5",
                "active_color": "#1b5e20"
            }
        },
        "average_rating_range": [1, 2, 3, 4, 5],
        "average_rating_labels": [0, 1, 2, 3, 4, 5],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
    },
    "6": {
        "name": "1to10",
        "min_score": 0,
        "max_score": 10,
        "distributions": [{
            "value": 3,
            "label": "T3B",
            "color": "#10a754",
            "field_id": "top"
        }, {
            "value": 2,
            "label": "MB",
            "color": "#fab416",
            "field_id": "mid"
        }, {
            "value": 1,
            "label": "B3B",
            "color": "#ed2424",
            "field_id": "bottom"
        }],
        "prop": {
            "1": {
                "value": 1,
                "label": "#1",
                "active_color": "#b71c1c"
            },
            "2": {
                "value": 2,
                "label": "#2",
                "active_color": "#c62828"
            },
            "3": {
                "value": 3,
                "label": "#3",
                "active_color": "#d32f2f"
            },
            "4": {
                "value": 4,
                "label": "#4",
                "active_color": "#e53935"
            },
            "5": {
                "value": 5,
                "label": "#5",
                "active_color": "#f44336"
            },
            "6": {
                "value": 6,
                "label": "#6",
                "active_color": "#f5ea14"
            },
            "7": {
                "value": 7,
                "label": "#7",
                "active_color": "#bbd531"
            },
            "8": {
                "value": 8,
                "label": "#8",
                "active_color": "#66b846"
            },
            "9": {
                "value": 9,
                "label": "#9",
                "active_color": "#06521f"
            },
            "10": {
                "value": 10,
                "label": "#10",
                "active_color": "#1b5e20"
            }
        },
        "average_rating_range": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        "average_rating_labels": [0, 2, 4, 6, 8, 10],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
    },
    "7": {
        "name": "1to6",
        "min_score": 0,
        "max_score": 6,
        "distributions": [{
            "value": 3,
            "label": "T2B",
            "color": "#10a754",
            "field_id": "top"
        }, {
            "value": 2,
            "label": "MB",
            "color": "#fab416",
            "field_id": "mid"
        }, {
            "value": 1,
            "label": "B2B",
            "color": "#ed2424",
            "field_id": "bottom"
        }],
        "prop": {
            "1": {
                "value": 1,
                "label": "#1",
                "active_color": "#b71c1c"
            },
            "2": {
                "value": 2,
                "label": "#2",
                "active_color": "#d32f2f"
            },
            "3": {
                "value": 3,
                "label": "#3",
                "active_color": "#f44336"
            },
            "4": {
                "value": 4,
                "label": "#4",
                "active_color": "#f5ea14"
            },
            "5": {
                "value": 5,
                "label": "#5",
                "active_color": "#66b846"
            },
            "6": {
                "value": 6,
                "label": "#6",
                "active_color": "#1b5e20"
            }
        },
        "average_rating_range": [1, 2, 3, 4, 5, 6],
        "average_rating_labels": [0, 2, 4, 6],
        "percentage_labels": [0, 33, 67, 100],
        "number_of_ticks": 4
    },
    "8": {
        "name": "-3to+3",
        "min_score": -3,
        "max_score": 3,
        "distributions": [{
            "value": 2,
            "label": "Positives",
            "color": "#0b7139",
            "field_id": "positives"
        }, {
            "value": 1,
            "label": "Negatives",
            "color": "#ed2424",
            "field_id": "negatives"
        }],
        "prop": {
            "1": {
                "value": 1,
                "label": "#1",
                "active_color": "#f5ea14"
            },
            "2": {
                "value": 2,
                "label": "#2",
                "active_color": "#66b846"
            },
            "3": {
                "value": 3,
                "label": "#3",
                "active_color": "#1b5e20"
            },
            "-3": {
                "value": -3,
                "label": "#-3",
                "active_color": "#b71c1c"
            },
            "-2": {
                "value": -2,
                "label": "#-2",
                "active_color": "#d32f2f"
            },
            "-1": {
                "value": -1,
                "label": "#-1",
                "active_color": "#f44336"
            }
        },
        "average_rating_range": [-3, -2, -1, 0, 1, 2, 3],
        "average_rating_labels": [-3, -1, 1, 3],
        "percentage_labels": [0, 33, 67, 100],
        "number_of_ticks": 4
    },
    "9": {
        "name": "1to4",
        "min_score": 0,
        "max_score": 4,
        "distributions": [{
            "value": 3,
            "label": "TB",
            "color": "#10a754",
            "field_id": "top"
        }, {
            "value": 2,
            "label": "MB",
            "color": "#fab416",
            "field_id": "mid"

        }, {
            "value": 1,
            "label": "BB",
            "color": "#ed2424",
            "field_id": "bottom"
        }],
        "prop": {
            "1": {
                "value": 1,
                "label": "#1",
                "active_color": "#b71c1c"
            },
            "2": {
                "value": 2,
                "label": "#2",
                "active_color": "#e53935"
            },
            "3": {
                "value": 4,
                "label": "#4",
                "active_color": "#bbd531"
            },
            "4": {
                "value": 4,
                "label": "#4",
                "active_color": "#1b5e20"
            }
        },
        "average_rating_range": [1, 2, 3, 4],
        "average_rating_labels": [0, 1, 2, 3, 4],
        "percentage_labels": [0, 25, 50, 75, 100],
        "number_of_ticks": 5
    }
  }
  constructor() { }

  getRaterDetails(raterType) {
    if (raterType in this.raters) {
      return JSON.parse(JSON.stringify(this.raters[raterType]));
    } else if(raterType) {
      return {};
    } else {
        return JSON.parse(JSON.stringify(this.raters));
    }
  }
}
